const STAGING_ENVIRONMENTS = new Set(["staging", "stage"]);
export const INFLOW_BACKEND_ENVIRONMENT_CHANGED = "inflow:backend-environment-changed";
const STORAGE_KEY = "inflow:backend-environment";

export function isInflowStagingBuild() {
  return STAGING_ENVIRONMENTS.has(String(process.env.REACT_APP_ENV || "").trim().toLowerCase());
}

export function getInflowBackendEnvironment() {
  if (!isInflowStagingBuild()) return "production";
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "production" ? "production" : "staging";
  } catch {
    return "staging";
  }
}

export function getInflowBackendUrl() {
  if (isInflowStagingBuild() && getInflowBackendEnvironment() === "production") {
    return String(process.env.REACT_APP_PRODUCTION_BACKEND_URL || "https://api.inflowreos.com").replace(/\/+$/, "");
  }
  return String(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
}

export function setInflowBackendEnvironment(environment) {
  if (!isInflowStagingBuild()) return;
  const next = environment === "production" ? "production" : "staging";
  try { window.localStorage.setItem(STORAGE_KEY, next); } catch {}
  window.dispatchEvent(new CustomEvent(INFLOW_BACKEND_ENVIRONMENT_CHANGED, { detail: { environment: next } }));
}
